import React, {useState} from 'react';
import { Grid, Row, Col } from '../../styles/GlobalTheme/GlobalStyledComponents';
import { NavDetails, NavList, NavIcon, NavItemsTitle, 
        NavItem, NavMobile, NavMobileItem, NavMobileLink,
        ContactTitle, ContactText } from './StyledComponents';
import { NavBar, Nav, Logo,
    NavMenu, NavSelector, NavMenuTitle, NavMenuLinks, SvgBox } from './NavBarElements';
import { AnimatePresence } from 'framer-motion';
import { MdChevronRight, MdChevronLeft } from 'react-icons/md';
import Fade from 'react-reveal/Fade';
import { useHistory } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-transition-group';
import { SvgIcons } from '../Card/SvgComponents';
import px2vw from '../../utils/px2vw'


const Navbar = (props) => {
    const [style, setStyle] = useState({opacity: 0});
    const [style2, setStyle2] = useState({opacity: 0});
    const [navData, setData] = useState({data: ''});
    const [selMenu, selIndex] = useState({data: null});
    const [isOpen, setIsOpen] = useState(false);
    const [selector, setSelector] = useState(false);
    const [getMobileMenu, setMobileMenu] = useState({data: props.data.mobileMenu});
    const [getMobileBackMenu, setMobileBackMenu] = useState([]);

    const history = useHistory();

    const routeChange = () =>{ 
        let path = `/home`; 
        history.push(path);
    }

    const iconVariants = {
        opened: {
            rotate: 90
        },
        closed: {
            rotate: 0
        }
    };

    const navClick = (data) => {
        setMobileMenu({data: data});
        setMobileBackMenu(getMobileBackMenu.concat({data: getMobileMenu.data}))
    };

    const navBack = (data) => {
        setMobileMenu(getMobileBackMenu.pop());
    }
            
    function getSvgSize() {
        let svgsize = px2vw(40);
        if (window.innerWidth <= 425) {
            svgsize = px2vw(130);
        } 
        return svgsize;
    }
    return (
        <NavBar>
            <Nav>
                <Logo id="qlogo" to="/" logoFontFamily="Azonix" onClick={routeChange}><img src={props.data.logo} alt='logo'/><p>Qberaa</p></Logo>
                {/* <MenuBars /> */}
                <NavMenu>
                    {props.data.list.map((item, index) => (
                        <NavMenuLinks to={item.link} key={index}
                        onMouseEnter={e => {
                            setStyle({opacity: 1,
                                'WebkitTransition': 'opacity 0.5s ease-in-out',
                                'MozTransition': 'opacity 0.5s ease-in-out',
                                'transition': 'opacity 0.5s ease-in-out',
                            });
                            setData({data: item.data});
                            selIndex({data: index});
                        }}
                        >
                            <NavMenuTitle>{item.title}</NavMenuTitle>
                            {(selMenu.data === index)  && ((navData.data.cols) && (navData.data.cols.length > 0) || (navData.data.content)) && (
                            <NavSelector style={style}
                                exit={{ opacity: 0}}
                                initial={{ opacity: 0}}
                                animate={{ opacity: 1,
                                    'WebkitTransition': 'opacity 0.5s ease-in-out',
                                    'MozTransition': 'opacity 0.5s ease-in-out',
                                    'transition': 'opacity 0.5s ease-in-out',}}
                                onMouseLeave={e => {
                                    setStyle({opactiy: 0})
                                    // selIndex({data: null})
                                    // setData({data: ''})
                                }}></NavSelector>
                            )}
                        </NavMenuLinks>
                    ))}
                    <SvgBox
                        variants={iconVariants}
                        animate={isOpen ? "opened" : "closed"}
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {/* <svg viewBox="0 0 100 80" width="40" height="40">
                        <rect width="100" height="20"></rect>
                        <rect y="30" width="100" height="20"></rect>
                        <rect y="60" width="100" height="20"></rect>
                        </svg> */}

                        <SvgIcons pageshow="hMenu" size={getSvgSize()}></SvgIcons>
                    </SvgBox>
                </NavMenu>
            </Nav>
            <Fade right cascade duration={800}>
            {(isOpen) && (<NavMobile>
                {getMobileMenu.data.map((item, index) => (
                    ((item.item !== 'Back') && (item.children.length === 0) && (<NavMobileItem>
                        <NavMobileLink to={item.link} key={index}
                        onClick={() => setIsOpen(!isOpen)}
                        >{item.item}</NavMobileLink>
                        {!(item.link.length > 0) && (<MdChevronRight />)}
                    </NavMobileItem>)) ||
                    ((item.item === 'Back') && (item.children.length === 0) && (<NavMobileItem>
                        <NavMobileLink onClick={() => {
                            navBack(item);
                            }} key={index}>{item.item}</NavMobileLink>
                        {!(item.link.length > 0) && (<MdChevronLeft />)}
                    </NavMobileItem>)) ||
                    ((item.children.length !== 0) && (<NavMobileItem>
                        <NavMobileLink onClick={() => {
                            navClick(item.children);
                        }}
                        key={index}>{item.item}</NavMobileLink>
                        {!(item.link.length > 0) && (<MdChevronRight />)}
                    </NavMobileItem>))
                ))}
            </NavMobile>)}
            </Fade>
            <AnimatePresence>
                {(navData.data.cols) && (navData.data.cols.length > 0) && (
                    <NavDetails justifyContent="space-around"
                        style={style2}
                        exit={{ opacity: 0}}
                        initial={{ opacity: 0}}
                        animate={{ opacity: 1,
                            'WebkitTransition': 'opacity 0.5s ease-in-out',
                            'MozTransition': 'opacity 0.5s ease-in-out',
                            'transition': 'opacity 0.5s ease-in-out',}}
                        onMouseEnter={() => setSelector(true)}
                        onMouseLeave={e => {
                            setStyle2({opactiy: 0,
                                'WebkitTransition': 'opacity 0.5s ease-in-out',
                                'MozTransition': 'opacity 0.5s ease-in-out',
                                'transition': 'opacity 0.5s ease-in-out',})
                            setData({data: ''})
                        }}
                        onClick={e => {
                            setStyle2({opactiy: 0,
                                'WebkitTransition': 'opacity 0.5s ease-in-out',
                                'MozTransition': 'opacity 0.5s ease-in-out',
                                'transition': 'opacity 0.5s ease-in-out',})
                            setData({data: ''})
                        }}
                        >
                        {(navData.data.cols.length > 0) && (navData.data.cols.map((item, index1) => { return (
                            <NavList key={index1+400}>
                                <NavIcon><img src={item.icon} alt='icon'></img></NavIcon>
                                <NavItemsTitle>{item.title}</NavItemsTitle>
                                {item.items.map((item, index3) => { return (
                                    <NavItem to={item.link} key={index3+500}>{item.linkName}</NavItem>
                                    )}
                                )}
                            </NavList>
                            )}
                        ))}
                    </NavDetails>
                )}
                {(navData.data.content) && (navData.data.content[0]) && (
                    <NavDetails justifyContent="flex-end" style={style}
                        exit={{ opacity: 0,
                            'WebkitTransition': 'opacity 0.5s ease-in-out',
                            'MozTransition': 'opacity 0.5s ease-in-out',
                            'transition': 'opacity 0.5s ease-in-out',}}
                        initial={{ opacity: 0}}
                        animate={{ opacity: 1,
                            'WebkitTransition': 'opacity 0.5s ease-in-out',
                            'MozTransition': 'opacity 0.5s ease-in-out',
                            'transition': 'opacity 0.5s ease-in-out',}}
                        onMouseEnter={() => setSelector(true)}
                        onMouseLeave={e => {
                            setStyle({opactiy: 0,
                                'WebkitTransition': 'opacity 0.5s ease-in-out',
                                'MozTransition': 'opacity 0.5s ease-in-out',
                                'transition': 'opacity 0.5s ease-in-out',})
                            setData({data: ''})
                        }}
                        onClick={e => {
                            setStyle({opactiy: 0})
                            setData({data: ''})
                        }}>
                        <Grid bgColor="white" pr="0" mt="86">
                            <Row justifyContent="space-between">{(navData.data.content[0].contactInfo) && (navData.data.content[0].contactInfo.length > 0) && 
                            (navData.data.content[0].contactInfo.map((item, index)=> { return (
                                <Row>
                                <img style={{paddingRight: "12px"}} src={item.icon}/>
                                <ContactTitle>{item.text}</ContactTitle>
                                </Row>
                            )})
                            )}
                            </Row>
                            <Row mt="50"><ContactText>{navData.data.content[0].text}</ContactText></Row>
                        </Grid>
                    </NavDetails>
                    )}
            </AnimatePresence>                    
        </NavBar>
    );
}

export default Navbar
